import {emptyQuestion,gradeQuestion,contentText,type Question} from './question-model';
import type {InteractiveQuestionBlock} from './interactive-activity';

export type QuestionVerdict = 'green'|'orange'|'red';
export function automaticQuestionVerdict(block:InteractiveQuestionBlock,value:string):QuestionVerdict|null {
 if(block.correctionMode==='teacher'||!value.trim())return null;
 if(block.answerType==='mcq'){
  const correct=(block.options??[]).filter(o=>o.correct).map(o=>o.id);
  if(!correct.length)return null;
  try{
   const selected:unknown=JSON.parse(value);
   if(!Array.isArray(selected)||selected.some(id=>typeof id!=='string'))return 'red';
   if(!selected.length)return null;
   const unique=[...new Set(selected)];
   if(unique.length===correct.length&&unique.every(id=>correct.includes(id)))return 'green';
   return unique.some(id=>correct.includes(id))?'orange':'red';
  }catch{return 'red';}
 }
 if(block.answerType==='true_false'&&block.correction?.acceptedAnswers?.length){
  return block.correction.acceptedAnswers.some(a=>a.trim().toLowerCase()===value.trim().toLowerCase())?'green':'red';
 }
 const result=gradeActivityQuestion(block,value);
 return result===null?null:result?'green':'red';
}

/** Adapt existing activity questions to the shared grader; call with teacher data only. */
export function gradeActivityQuestion(block:InteractiveQuestionBlock,value:string):boolean|null {
 if(block.correctionMode==='teacher'||!value.trim())return null;
 let q:Question;
 if(block.answerType==='numeric'&&block.correction?.numericAnswer!==undefined){
  q={...emptyQuestion('numeric'),type:'numeric',response:{unitInput:false},answer:{referenceAnswer:{type:'numeric',value:block.correction.numericAnswer,unit:block.correction.unit??block.answerUnit??'',tolerance:block.correction.tolerance??0}}};
  return gradeQuestion(q,{type:'numeric',value,unit:''}).correct;
 }
 if(block.answerType==='mcq'){
  q={...emptyQuestion('multiple-choice'),type:'multiple-choice',response:{options:(block.options??[]).map(o=>({id:o.id,content:contentText(o.text)}))},answer:{mode:'ids',correctIds:(block.options??[]).filter(o=>o.correct).map(o=>o.id)}};
  try{return gradeQuestion(q,{type:'multiple-choice',selectedIds:JSON.parse(value)}).correct;}catch{return false;}
 }
 return null;
}
